import React, { Fragment, useEffect, useState } from 'react';
import useStores, { observer } from "stores";
import { Card, Select } from 'antd';
import ImgView from 'components/common/FileController/ImgView';
import { COMPANY_TYPE } from 'constant';
import './GoodsListBanz.css';

const GoodsList = ({ onSelect, detailGoods, cGbn }) => {
  const { orderStore, goodsGroupStore } = useStores();
  const [goodsGroupCd, setGoodsGroupCd] = useState('');
  const [hoveredItemId, setHoveredItemId] = useState(null);

  useEffect(() => {
    orderStore.orderGoodsList('', '', '', true);
    
    (cGbn === COMPANY_TYPE.BENZ) && goodsGroupStore.disGoodsGroupList(null, null, 'N');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const TextContainer = (data) => {
    const { gdNm } = data;
    let fontSize = 14;

    return (
      <div
        style={{
          // width: 'calc((100%) - 8px)',
          maxHeight: '48px',
          height: '48px', // 고정 높이 추가
          whiteSpace: "pre-wrap",
          overflowWrap: 'break-word', /* 긴 단어 줄바꿈 처리 */
          overflow: 'hidden', /* 내용이 넘칠 경우 숨김 처리 */
          display: 'flex',/* flexbox 사용 */
          flexDirection: 'column', /* 세로 방향으로 배치 */
          alignItems: 'center',/* 세로 중앙 정렬 */
          textOverflow: 'ellipsis',
          justifyContent: 'center',/* 가로 중앙 정렬 */
          textAlign: 'center',  /* 텍스트 가운데 정렬 */
          fontSize: `${fontSize}px`, // state로 관리되는 글꼴 크기 적용
          lineHeight: '1.0',/* 줄 간격 줄임 */
          color: '#000000',
          marginTop: '1px'
        }}
        onClick={()=>onSelect(data)}
      >
        {gdNm.split(`\n`).map((item, idx)=>{
          return (
            <Fragment key={idx}>
              <span style={idx > 0 ? { fontWeight: 'bold', marginTop: '-12px' } : {}}>
                {item}
              </span>
              {gdNm.split(`\n`).length > idx+1 && <br />}
            </Fragment>
        )})}
      </div>
    );
  };

  const goodsCard = (item, idx) => {
    if(cGbn === COMPANY_TYPE.BENZ && goodsGroupCd !== '' && goodsGroupCd !== item.pGdCd) return;
    return (
      <Card.Grid
        key={idx}
        hoverable={false} 
        className={(detailGoods?.gdCd === item?.gdCd && detailGoods?.pGdCd === item?.pGdCd) 
          ? "item_unip_card on" : "item_unip_card"}
      >
        <div 
          className="goods-image-container"
          onMouseEnter={() => setHoveredItemId(item?.pGdCd + item?.gdCd)}
          onMouseLeave={() => setHoveredItemId(null)}
        >
          <Card
            // title={TextContainer(item.gdNm)}
            hoverable
            cover={
              item?.gdImgUrlInfo_fileId &&
              <Fragment>
                <div className="image-wrapper" style={{ position: 'relative' }}>
                  <ImgView
                    viewGlass={hoveredItemId === (item?.pGdCd + item?.gdCd)} // 돋보기 기능 유지 
                    // viewGlass={true}
                    iconChnage={true}
                    fileInfo={{
                      fileId: item.gdImgUrlInfo_fileId,
                      fileName: item.gdImgUrlInfo_fileName,
                      physicalName: item.gdImgUrlInfo_physicalName,
                      serverSubPath: item.gdImgUrlInfo_serverSubPath,
                    }}
                    detailFileInfo={{
                      fileId: item?.gdDetailUrlInfo_fileId,
                      fileName: item?.gdDetailUrlInfo_fileName,
                      physicalName: item?.gdDetailUrlInfo_physicalName,
                      serverSubPath: item?.gdDetailUrlInfo_serverSubPath,
                    }}
                  />
                  {hoveredItemId === (item?.pGdCd + item?.gdCd) && (
                    <div 
                      className="button-bottom-container" 
                      onClick={()=>onSelect(item)}
                    >선택</div>
                  )}
                </div>
              </Fragment>
            }
            actions={[TextContainer(item)]}
          >
            {/* <Card.Meta title={TextContainer(item.gdNm)} />  */}
          </Card>
        </div>
      </Card.Grid>
    )
  }

  return (
    <Fragment>
      <div className="button-group">
        <h2>▶ 주문가능 근무복</h2>
        {cGbn === COMPANY_TYPE.BENZ &&
          <div className="button-right">
            <ul>
              <li><h3 style={{alignItems: 'center',display: 'flex', height: 32, color: 'blue' }}>직군구분</h3></li>
              <li>
                <Select
                  style={{ width: 200 }}
                  placeholder="직군구분"
                  value={goodsGroupCd}
                  onChange={(value)=>setGoodsGroupCd(value)}
                >
                  <Select.Option key={''}>전체</Select.Option>
                  {goodsGroupStore?.goodsGroupList.map(item=>
                    <Select.Option key={item.groupCd}>{item.groupNm}</Select.Option>)}
                </Select>
              </li>
            </ul>
          </div>
        }
      </div>
      <Card>
        {orderStore?.goodsList.map((item, idx)=>(
          goodsCard(item, idx)
        ))}
      </Card>
    </Fragment>
  );
}

export default observer(GoodsList);
